import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as interfaceActions from '../actions/contractSettingsActions';

const initState = {
  formFields: {
    section1_1: '24',
    section1_2: '24',
    section1_3: '24',
    section1_4: '24',
    section1_5: '24',

    section2_1: '12',
    section2_2: '15',
    section2_3: '12',
    section2_4: '15',
    section2_5: '2',
    section2_6: '15',
    section2_7: '1',
    section2_8: '15',

    section3_1: '12',
    section3_2: '15',
    section3_3: '12',
    section3_4: '15',
    section3_5: '2',
    section3_6: '15',
    section3_7: '1',
    section3_8: '15',

    section4_1: '30',
    section4_2: '24',
    section4_3: '48',
    section4_4: '30',

    section5_1: '24',
    section5_2: '24',
    section5_3: '24',
    section5_4: '24',
    section5_5: '24',

    section6_1: '40',
    section6_2: '40',
    section6_3: '40',
    section6_4: '40',
  },
};

const fields = handleActions(
  {
    [interfaceActions.setContractField]: (state, { payload }) => {
      localStorage['contract_settings_form'] = JSON.stringify({
        ...state,
        ...payload,
      });
      return { ...state, ...payload };
    },
  },

  localStorage['contract_settings_form']
    ? JSON.parse(localStorage['contract_settings_form'])
    : initState.formFields
);

export const contractSettings = combineReducers({
  fields,
});
